export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD1gZxAijaLdD8NCyO3TS9v1GcC3fxMU5E",
    authDomain: "prj-mlai-aipltfrm-poc-dev.firebaseapp.com",
    projectId: "prj-mlai-aipltfrm-poc-dev",
    storageBucket: "prj-mlai-aipltfrm-poc-dev.appspot.com",
    messagingSenderId: "301858312317",
    appId: "1:301858312317:web:9c6de287153c756f516114"
  },
  firebaseTenantId: 'noovle-studio-n60ug',
  apiPath: '/api/v1',
  API: {
    mocked: 'assets/mocks',
  },
  basemap: {
    osm: 'https://c.tile.openstreetmap.org/{z}/{x}/{y}.png',
    darkCarto: 'https://cartodb-basemaps-a.global.ssl.fastly.net/dark_all/{z}/{x}/{y}{r}.png',
  },
  logoutTimeout: 3600,
  warningTimeout: 3300,
};
